import { useContext } from "react";
import { MultiSymbolMarginContext } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/MultiSymbolMargin.context";
import { getSymbolMarginPreview } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/utils";

const useGlobalSettings = () => {
  const {
    globalSettingsExpanded,
    setGlobalSettingsExpanded,
    pendingGlobalMultiplier,
    pendingGlobalLeverageType,
    pendingGlobalMarginType,
    isViewOnly,
    isFullScreen,
  } = useContext(MultiSymbolMarginContext)!;

  const onExpandCollapseClick = () => {
    setGlobalSettingsExpanded(!globalSettingsExpanded);
  };

  const rawPreview = getSymbolMarginPreview({
    marginType: pendingGlobalMarginType,
    multiplier: pendingGlobalMultiplier,
    leverageType: pendingGlobalLeverageType,
  });
  const globalSettingsPreview =
    typeof rawPreview === "string"
      ? rawPreview
      : `${rawPreview.marginType} - ${rawPreview.multiplier}`;

  return {
    globalSettingsExpanded: globalSettingsExpanded || !!isViewOnly,
    onExpandCollapseClick,
    globalSettingsPreview,
    isViewOnly,
    isFullScreen,
  };
};

export default useGlobalSettings;
